// src/config/fundConfigurations.js
// קונפיגורציות עבור השוואות קרנות לפי קטגוריות

  /**
   * 📊 קונפיגורציות התמחויות מפורטות לכל קטגוריה
   */
export const getSpecializationConfigs = (category, categoryTitle = '') => {
    switch (category) {
      case 'study-funds': // קרנות השתלמות
        return [
          {
            key: 'כללי',
            title: `${categoryTitle} - כללי`,
            description: 'מסלול כללי הוא ברירת המחדל ברוב הגופים – ולכן גם המסלול הנפוץ ביותר בקרב החוסכים. מסלול זה מציע שילוב כמעט שווה בין מניות לאג"ח, תיק מאוזן בין סיכון ליציבות. רמת סיכון 3 מתוך 5 המקביל ברמת הסיכון שלו על פי הגדרת משרד האוצר לחוסכים בני 50 עד 60, שטווח ההשקעה שלהם לרוב לא פחות מ-3 שנים.',
            fundIds: [962, 964, 880, 12535, 456, 1162, 579, 1093,828,154]
          },
          {
            key: 'מניות',
            title: `${categoryTitle} - מניות`,
            description: 'מסלול מניות מיועד לחוסכים שמעוניינים בפוטנציאל תשואה גבוה, ומוכנים להתמודד עם תנודתיות גבוהה לאורך הדרך. המסלול מושקע ברובו במניות, בישראל ובעולם, ונחשב למסלול אגרסיבי עם רמת סיכון גבוהה. רמת סיכון 5 מתוך 5, המקבילה לחוסכים צעירים יחסית, בעלי טווח השקעה ארוך של 5 שנים ויותר.',
            fundIds: [ 12536,   883,  968, 869, 1350, 963 , 1256, 763,   8563,1377]
          },
          {
            key: 'עוקב-מדדי-מניות',
            title: `${categoryTitle} - עוקב מדדי מניות`,
            description: 'מסלול זה משקיע במניות העוקבות אחר מדדי מניות מובילים בארץ ובעולם, באמצעות ניהול פאסיבי המתמקד בנכסים סחירים. המסלול מתאים לחוסכים המעוניינים בחשיפה רחבה למדדי מניות, עם עלויות ניהול נמוכות יחסית ורמת סיכון גבוהה (5 מתוך 5).',
            fundIds: [15241, 15312, 14790, 15007, 15300, 15308, 14863, 14418, 14945, 15356]
          },
          {
            key: 'sp500',
            title: `${categoryTitle} - S&P 500`,
            description: 'מסלול זה עוקב אחר מדד S&P 500 – הכולל את 500 החברות עם השווי שוק הגדול ביותר בארה"ב. ההשקעה מתבצעת ברובה במניות חו"ל, בדגש על מגזרים מובילים, ולרוב היא חשופה במרבית ההשקעה לדולר האמריקאי. המסלול בעל תנודתיות גבוהה ורמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה ארוך של 5 שנים ומעלה, המוכנים לתנודות חדות בטווח הקצר לטובת פוטנציאל רווח בטווח הארוך.',
            fundIds: [14862, 13853, 13342, 14668, 13873, 13502, 13264, 13245, 9451, 14849]
          },
          {
            key: 'אג"ח-ממשלות',
            title: `${categoryTitle} - אג"ח ממשלות`,
            description: 'מסלול זה משקיע ברובו באגרות חוב ממשלתיות – מהאגרות היותר סולידיות, עם חשיפה מזערית או ללא חשיפה כלל למניות. הוא מציע יציבות גבוהה יחסית ותנודתיות נמוכה, ומתאים לחוסכים המחפשים הגנה על ההון יותר מאשר מקסום תשואה. רמת סיכון 1 מתוך 5, ומתאימה במיוחד לטווחי השקעה קצרים עד בינוניים או למי שמעוניין בצמצום סיכון משמעותי, ביחס לאלטרנטיבות השקעה תנודתיות יותר.',
            fundIds: [1399, 973, 865, 1387, 1361]
          },
          {
            key: 'משולב-סחיר',
            title: `${categoryTitle} - משולב סחיר`,
            description: 'מסלול זה משקיע בעיקר בניירות ערך סחירים – מניות ואגרות חוב, בארץ ובעולם, ישירות או באמצעות נגזרים. רמות הסיכון נעות לרוב בין 3 ל־4 מתוך 5, ומתאימות לחוסכים עם טווח השקעה בינוני עד ארוך, המעוניינים בחשיפה לשוק ההון אך לא במסלול מנייתי מלא.',
            fundIds: [15458, 8779, 15426, 15235, 15448, 15466, 1034, 15211, 15355]
          },
          {
            key: 'הלכתי',
            title: `${categoryTitle} - הלכתי`,
            description: 'מסלול זה מנוהל בהתאם לכללי ההלכה היהודית, ומסנן השקעות בתחומים שאינם עומדים בקריטריונים ההלכתיים. ההשקעות מתבצעות במניות, אג"ח ונכסים נוספים, בארץ ובעולם, תוך הקפדה על פיקוח הלכתי צמוד. רמות הסיכון משתנות בהתאם להרכב ההשקעות בפועל, אך לרוב נעות סביב 3 מתוך 5, ומתאימות לחוסכים המבקשים לשלב בין השקעה בשוק ההון לבין שמירה על עקרונות ההלכה.',
            fundIds: [12256, 1534, 2048, 13869, 1523, 9528, 768]
          },
          {
            key: 'אשראי-ואגח',
            title: `${categoryTitle} - אשראי ואג"ח`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, וכן בהעמדת אשראי לחברות וגופים מוסדיים. המיקוד באפיקים אלה מאפשר פוטנציאל לתשואה יציבה יחסית, עם תנודתיות נמוכה מאוד בהשוואה למסלולי מניות. רמת סיכון 1 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית במיוחד, תוך חשיפה מזערית או ללא חשיפה למניות.',
            fundIds: [14483, 716, 1319, 972, 13357, 1348, 1240, 199, 1485, 1378]
          },
          {
            key: 'עוקב-מדדים-גמיש',
            title: `${categoryTitle} - עוקב מדדים גמיש`,
            description: 'מסלול זה משקיע במגוון מדדי מניות ואג"ח, בארץ ובעולם, תוך שמירה על גמישות בהרכב ההשקעה בין המדדים השונים. הגמישות מאפשרת התאמה מהירה לשינויים בשווקים, עם אפשרות להגדיל או להפחית חשיפה למניות בהתאם לתנאי השוק. מסלול זה מתאים לחוסכים המעוניינים בנכסים העוקבים אחר מדדי מניות או אג"ח, באמצעות ניהול פאסיבי. רמות הסיכון נעות בין 3 ל־4 מתוך 5, ומתאימות לחוסכים בעלי טווח השקעה בינוני עד ארוך, המוכנים להתמודד עם תנודתיות בינונית-גבוהה לטובת פוטנציאל תשואה גבוה יותר.',
            fundIds: [ 15311, 11408,481,15028, 7256,14657,8629, 14680, 15239, 15297]
          },
          {
            key: 'אשראי-ואגח-עם-מניות',
            title: `${categoryTitle} - אשראי ואג"ח עם מניות עד 25%`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, ובהעמדת אשראי לחברות וגופים מוסדיים, עם חשיפה מוגבלת למניות של עד 25% מהנכסים. השילוב בין אפיקי החוב למניות מאפשר פוטנציאל לתשואה גבוהה יותר ממסלול אג"ח טהור, לצד שמירה על רמת תנודתיות מתונה. רמת סיכון 2 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית-מתונה, עם פוטנציאל צמיחה נוסף בזכות החשיפה המוגבלת למניות.',
            fundIds: [558, 8679, 8885, 12956, 1100, 12599, 416, 15340,1038,9662]
          }
        ];
        
      case 'pension-savings': // קופות גמל
        return [
          {
            key: 'עד-50',
            title: `${categoryTitle} - עד גיל 50`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים עד גיל 50, ומתאפיין בחשיפה גבוהה יחסית למניות – לרוב עד 60% מהנכסים. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך, גם במחיר של תנודתיות גבוהה יותר בטווח הקצר. רמת סיכון 4 מתוך 5, ומתאימה לחוסכים צעירים יחסית, בעלי אופק השקעה ארוך של מעל 5 שנים, המוכנים להתמודד עם ירידות בשוק ההון לטובת תשואה גבוהה בטווח הארוך.',
            fundIds: [9730,12532,7215,9916,9651,9779,9793,9939,9744,9950]
          },
          {
            key: '50-60',
            title: `${categoryTitle} - גיל 50-60`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים בגילאי 50 עד 60, ומשלב חשיפה מאוזנת בין מניות לאג"ח – לרוב סביב 50% מניות. המטרה היא לאזן בין צמיחת ההון לבין הגנה חלקית מפני תנודתיות גבוהה, בתקופה הקרובה יחסית לגיל הפרישה. רמת סיכון 3 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה בינוני של מספר שנים, המעוניינים לשמור על פוטנציאל תשואה לצד יציבות יחסית.',
            fundIds: [9529, 103, 9731, 12533, 9940, 9780, 9652, 9742, 9792, 9951]
          },
          {
            key: 'מעל-60',
            title: `${categoryTitle} - מעל גיל 60`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים מגיל 60 ומעלה, ומתאפיין בחשיפה נמוכה יחסית למניות – לרוב עד 25% מהנכסים. המטרה היא לשמור על הון החיסכון לקראת ובמהלך תקופת הפרישה, עם דגש על יציבות והפחתת תנודתיות. רמת סיכון 2 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה בינוני–קצר, המעוניינים בצמיחה מתונה לצד שמירה על חלק ניכר מההון בסיכון נמוך.',
            fundIds: [9941, 9745, 551, 9794, 401, 9781, 9732, 12534, 9952,9653]
          },
          {
            key: 'מניות-גמל',
            title: `${categoryTitle} - מניות`,
            description: 'מסלול מניות מיועד לחוסכים שמעוניינים בפוטנציאל תשואה גבוה, ומוכנים להתמודד עם תנודתיות גבוהה לאורך הדרך. המסלול מושקע ברובו במניות, בישראל ובעולם, ונחשב למסלול אגרסיבי עם רמת סיכון גבוהה. רמת סיכון 5 מתוך 5, המקבילה לחוסכים צעירים יחסית, בעלי טווח השקעה ארוך של 5 שנים ויותר.',
            fundIds: [1036, 761, 877,  1364, 961, 12531,863, 127,  814, 1375 ]
          },
          {
            key: 'sp500-גמל',
            title: `${categoryTitle} - S&P 500`,
            description: 'מסלול זה עוקב אחר מדד S&P 500 – הכולל את 500 החברות עם השווי שוק הגדול ביותר בארה"ב. ההשקעה מתבצעת ברובה במניות חו"ל, בדגש על מגזרים מובילים, ולרוב היא חשופה במרבית ההשקעה לדולר האמריקאי. המסלול בעל תנודתיות גבוהה ורמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה ארוך של 5 שנים ומעלה, המוכנים לתנודות חדות בטווח הקצר לטובת פוטנציאל רווח בטווח הארוך.',
            fundIds: [14858, 15419, 13855, 13946, 13501, 13263, 13246, 9452, 13343, 13565]
          },
          {
            key: 'עוקב-מדדי-מניות',
            title: `${categoryTitle} - עוקב מדדי מניות`,
            description: 'מסלול זה משקיע במניות העוקבות אחר מדדי מניות מובילים בארץ ובעולם, באמצעות ניהול פאסיבי המתמקד בנכסים סחירים. המסלול מתאים לחוסכים המעוניינים בחשיפה רחבה למדדי מניות, עם עלויות ניהול נמוכות יחסית ורמת סיכון גבוהה (5 מתוך 5).',
            fundIds: [1689, 15055, 989, 15293, 13356, 15310, 15210, 15249, 15093, 15423]
          },
          {
            key: 'עוקב-מדדים-גמיש-גמל',
            title: `${categoryTitle} - עוקב מדדים גמיש`,
            description: 'מסלול זה משקיע במגוון מדדי מניות ואג"ח, בארץ ובעולם, תוך שמירה על גמישות בהרכב ההשקעה בין המדדים השונים. הגמישות מאפשרת התאמה מהירה לשינויים בשווקים, עם אפשרות להגדיל או להפחית חשיפה למניות בהתאם לתנאי השוק. מסלול זה מתאים לחוסכים המעוניינים בנכסים העוקבים אחר מדדי מניות או אג"ח, באמצעות ניהול פאסיבי. רמות הסיכון נעות בין 3 ל־4 מתוך 5, ומתאימות לחוסכים בעלי טווח השקעה בינוני עד ארוך, המוכנים להתמודד עם תנודתיות בינונית-גבוהה לטובת פוטנציאל תשואה גבוה יותר.',
            fundIds: [14293, 14201, 14265, 14272, 14354, 15234, 14279, 14237, 14228, 14394]
          },
          {
            key: 'משולב-סחיר-גמל',
            title: `${categoryTitle} - משולב סחיר`,
            description: 'מסלול זה משקיע בעיקר בניירות ערך סחירים – מניות ואגרות חוב, בארץ ובעולם, ישירות או באמצעות נגזרים. רמות הסיכון נעות לרוב בין 3 ל־4 מתוך 5, ומתאימות לחוסכים עם טווח השקעה בינוני עד ארוך, המעוניינים בחשיפה לשוק ההון אך לא במסלול מנייתי מלא.',
            fundIds: [14292, 14202, 14264, 14271, 14353, 14281, 14236, 14342, 14229, 818]
          },
          {
            key: 'אשראי-ואגח-גמל',
            title: `${categoryTitle} - אשראי ואג"ח`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, וכן בהעמדת אשראי לחברות וגופים מוסדיים. המיקוד באפיקים אלה מאפשר פוטנציאל לתשואה יציבה יחסית, עם תנודתיות נמוכה מאוד בהשוואה למסלולי מניות. רמת סיכון 1 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית במיוחד, תוך חשיפה מזערית או ללא חשיפה למניות.',
            fundIds: [1037, 1335, 1376, 13355, 385, 14481, 8012, 223, 117, 813]
          },
          {
            key: 'הלכתי-גמל',
            title: `${categoryTitle} - הלכתי`,
            description: 'מסלול זה מנוהל בהתאם לכללי ההלכה היהודית, ומסנן השקעות בתחומים שאינם עומדים בקריטריונים ההלכתיים. ההשקעות מתבצעות במניות, אג"ח ונכסים נוספים, בארץ ובעולם, תוך הקפדה על פיקוח הלכתי צמוד. רמות הסיכון משתנות בהתאם להרכב ההשקעות בפועל, אך לרוב נעות סביב 3 מתוך 5, ומתאימות לחוסכים המבקשים לשלב בין השקעה בשוק ההון לבין שמירה על עקרונות ההלכה.',
            fundIds: [1524, 767, 9795, 2017, 1533,15452]
          },
      
          {
            key: 'אגח-ממשלות-גמל',
            title: `${categoryTitle} - אג"ח ממשלות`,
            description: 'מסלול זה משקיע ברובו באגרות חוב ממשלתיות – מהאגרות היותר סולידיות, עם חשיפה מזערית או ללא חשיפה כלל למניות. הוא מציע יציבות גבוהה יחסית ותנודתיות נמוכה, ומתאים לחוסכים המחפשים הגנה על ההון יותר מאשר מקסום תשואה. רמת סיכון 1 מתוך 5, ומתאימה במיוחד לטווחי השקעה קצרים עד בינוניים או למי שמעוניין בצמצום סיכון משמעותי, ביחס לאלטרנטיבות השקעה תנודתיות יותר.',
            fundIds: [1360, 1386, 15343, 1395, 859, 1412]
          }
        ];

      case 'investment-funds': // גמל להשקעה
        return [
          {
            key: 'כללי-השקעה',
            title: `${categoryTitle} - כללי`,
            description: 'מסלול כללי הוא ברירת המחדל ברוב הגופים – ולכן גם המסלול הנפוץ ביותר בקרב החוסכים. מסלול זה מציע שילוב כמעט שווה בין מניות לאג"ח, תיק מאוזן בין סיכון ליציבות. רמת סיכון 3 מתוך 5 המקביל ברמת הסיכון שלו על פי הגדרת משרד האוצר לחוסכים בני 50 עד 60, שטווח ההשקעה שלהם לרוב לא פחות מ-3 שנים.',
            fundIds: [11390, 8675, 7798, 8211, 7908, 12538, 7978, 7834, 7936, 7988]
          },
          {
            key: 'מניות-השקעה',
            title: `${categoryTitle} - מניות`,
            description: 'מסלול מניות מיועד לחוסכים שמעוניינים בפוטנציאל תשואה גבוה, ומוכנים להתמודד עם תנודתיות גבוהה לאורך הדרך. המסלול מושקע ברובו במניות, בישראל ובעולם, ונחשב למסלול אגרסיבי עם רמת סיכון גבוהה. רמת סיכון 5 מתוך 5, המקבילה לחוסכים צעירים יחסית, בעלי טווח השקעה ארוך של 5 שנים ויותר.',
            fundIds: [12537, 8522, 7860, 7975, 7934, 7836, 11394, 7991, 7799],

            hiddenFundIds: [11407]
          },
          {
            key: 'sp500-השקעה',
            title: `${categoryTitle} - S&P 500`,
            description: 'מסלול זה עוקב אחר מדד S&P 500 – הכולל את 500 החברות עם השווי שוק הגדול ביותר בארה"ב. ההשקעה מתבצעת ברובה במניות חו"ל, בדגש על מגזרים מובילים, ולרוב היא חשופה במרבית ההשקעה לדולר האמריקאי. המסלול בעל תנודתיות גבוהה ורמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה ארוך של 5 שנים ומעלה, המוכנים לתנודות חדות בטווח הקצר לטובת פוטנציאל רווח בטווח הארוך.',
            fundIds: [13259, 13250,7958, 13344, 13563, 14865, 13874, 13854, 13414, 15420]
          },
     
          {
            key: 'הלכתי-השקעה',
            title: `${categoryTitle} - הלכתי`,
            description: 'מסלול זה מנוהל בהתאם לכללי ההלכה היהודית, ומסנן השקעות בתחומים שאינם עומדים בקריטריונים ההלכתיים. ההשקעות מתבצעות במניות, אג"ח ונכסים נוספים, בארץ ובעולם, תוך הקפדה על פיקוח הלכתי צמוד. רמות הסיכון משתנות בהתאם להרכב ההשקעות בפועל, אך לרוב נעות סביב 3 מתוך 5, ומתאימות לחוסכים המבקשים לשלב בין השקעה בשוק ההון לבין שמירה על עקרונות ההלכה.',
            fundIds: [7863, 8716, 7937, 8523, 12257,7994]
          },
          {
            key: 'אשראי-אגח-השקעה',
            title: `${categoryTitle} - אשראי ואג"ח`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, וכן בהעמדת אשראי לחברות וגופים מוסדיים. המיקוד באפיקים אלה מאפשר פוטנציאל לתשואה יציבה יחסית, עם תנודתיות נמוכה מאוד בהשוואה למסלולי מניות. רמת סיכון 1 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית במיוחד, תוך חשיפה מזערית או ללא חשיפה למניות.',
            fundIds: [14482, 7862, 7905, 7801, 11391, 7989, 14944, 7837, 13354, 15283]
          },
          {
            key: 'אשראי-ואגח-עד-25-מניות-השקעה',
            title: `${categoryTitle} - אשראי ואג"ח עד 25% מניות`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, ובהעמדת אשראי לחברות וגופים מוסדיים, עם חשיפה מוגבלת למניות של עד 25% מהנכסים. השילוב בין אפיקי החוב למניות מאפשר פוטנציאל לתשואה גבוהה יותר ממסלול אג"ח טהור, לצד שמירה על רמת תנודתיות מתונה. רמת סיכון 2 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית-מתונה, עם פוטנציאל צמיחה נוסף בזכות החשיפה המוגבלת למניות.',
            fundIds: [12955, 8521, 7980, 7935, 7992, 7906, 11392, 7986, 7800]
          }
        ];

      case 'child-savings': // תוכנית חיסכון לכל ילד
        return [
          {
            key: 'סיכון-מוגבר',
            title: `${categoryTitle} - לחוסכים המעדיפים סיכון מוגבר`,
            description: 'מסלול זה משקיע בעיקר במניות, בארץ ובעולם, עם חשיפה של עד 100% לשוק ההון. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך, גם במחיר תנודתיות גבוהה בטווח הקצר. רמת סיכון 5 מתוך 5, ומתאימה לחוסכים עם אופק השקעה של מעל 10 שנים, המוכנים להתמודד עם ירידות חדות בשוק ההון לטובת תשואה גבוהה בעתיד.',
            fundIds: [ 11327, 11367, 11311, 11377, 9898, 11387, 11323, 9420]
          },
          {
            key: 'סיכון-בינוני',
            title: `${categoryTitle} - לחוסכים המעדיפים סיכון בינוני`,
            description: 'מסלול זה משלב השקעה במניות ואגרות חוב, בארץ ובעולם, עם חשיפה מאוזנת יחסית בין השניים. המטרה היא ליצור איזון בין צמיחת ההון לבין הגנה על יציבות יחסית. רמת סיכון 3 מתוך 5, ומתאימה לחוסכים עם אופק השקעה בינוני–ארוך של לפחות 5 שנים.',
            fundIds: [ 11326, 11366, 11312, 11376, 9897, 11386, 11322,9414]
          },
          {
            key: 'סיכון-מועט',
            title: `${categoryTitle} - לחוסכים המעדיפים סיכון מועט`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב ממשלתיות וקונצרניות, ופיקדונות, עם חשיפה מוגבלת למניות. המטרה היא לשמור על ערך ההשקעה ולצמצם תנודתיות, תוך השגת תשואה פוטנציאלית גבוהה יותר ממסלול אג"ח טהור. רמות הסיכון נעות בין 2 ל־3 מתוך 5, בהתאם להרכב ההשקעות בפועל בכל גוף מנהל, ומתאימות לחוסכים המעוניינים בהשקעה סולידית–מתונה לטווח קצר–בינוני.',
            fundIds: [11325, 11365, 11310, 11375, 9896, 9421, 11385, 11321]
          },
          {
            key: 'הלכתי-יהודי',
            title: `${categoryTitle} - מסלול הלכתי יהודי`,
            description: 'מסלול זה מנוהל בהתאם לכללי ההלכה היהודית, ומשקיע במניות, אגרות חוב ונכסים נוספים בארץ ובעולם, בכפוף לסינון השקעות בתחומים שאינם עומדים בקריטריונים ההלכתיים. רמת הסיכון נקבעת בהתאם להרכב בפועל, אך ברוב המקרים נעה סביב 3 מתוך 5, ומתאימה לחוסכים המבקשים לשלב השקעה בשוק ההון עם הקפדה על עקרונות ההלכה.',
            fundIds: [9113, 11320, 11335, 9895, 9555, 11328, 11388]
          },
          {
            key: 'הלכתי-איסלאמי',
            title: `${categoryTitle} - מסלול הלכתי איסלאמי`,
            description: 'מסלול זה מנוהל בהתאם לעקרונות השריעה האיסלאמית, ומשקיע במניות, אגרות חוב שריעתיות ונכסים נוספים, תוך הימנעות מהשקעות בתחומים האסורים לפי ההלכה האיסלאמית. רמת הסיכון נקבעת בהתאם להרכב ההשקעות, אך לרוב נעה סביב 3 מתוך 5, ומתאימה לחוסכים המבקשים השקעה התואמת לעקרונות השריעה.',
            fundIds: [11352, 9303]
          }
        ];

      case 'insurance-savings': // פוליסות חיסכון
        return [
          {
            key: 'כללי',
            title: `${categoryTitle} - כללי`,
            description: 'מסלול זה משקיע בשילוב בין מניות, אגרות חוב, ונכסים נוספים בארץ ובעולם. המטרה היא לאזן בין פוטנציאל תשואה לבין יציבות ההשקעה. רמת סיכון 3 מתוך 5, ומתאים לחוסכים עם אופק השקעה בינוני–ארוך של מעל 3 שנים.',
            fundIds: [116,9719,99,17013,50,13498,12937,9302,143]
          },
          {
            key: 'מניות',
            title: `${categoryTitle} - מניות`,
            description: 'מסלול זה משקיע ברובו במניות בארץ ובעולם. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך, גם במחיר תנודתיות גבוהה בטווח הקצר. רמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה של מעל 5 שנים.',
            fundIds: [115,9579,76,92,9,9720,13500,58,44,12938]
          },
          {
            key: 'sp500',
            title: `${categoryTitle} - מסלול מדד S&P 500`,
            description: 'מסלול זה משקיע במניות העוקבות אחר מדד S&P 500 – הכולל את 500 החברות עם השווי שוק הגדול ביותר בארה"ב – ולרוב חשוף במרביתו לדולר. המטרה היא להצמיד את הביצועים לשוק האמריקאי באמצעות ניהול פאסיבי. רמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה של מעל 5 שנים.',
            fundIds: [9554, 13346, 13434, 13625, 14169, 14316, 15062, 15108]
          },
     
          {
            key: 'אשראי-ואגח',
            title: `${categoryTitle} - אשראי ואג"ח`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב ממשלתיות וקונצרניות, ובהעמדת אשראי לחברות, עם חשיפה מזערית או ללא חשיפה למניות. המטרה היא לשמור על יציבות גבוהה ותנודתיות נמוכה. רמת סיכון 1 מתוך 5, ומתאים לחוסכים עם אופק השקעה קצר–בינוני.',
            fundIds: [4, 114, 42, 47, 89, 8659, 14425]
          },
          {
            key: 'אשראי-ואגח-עד-25-מניות',
            title: `${categoryTitle} - אשראי ואג"ח עד 25% מניות`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב ואשראי, עם חשיפה מוגבלת למניות של עד 25%. המטרה היא להוסיף פוטנציאל תשואה למסלול אג"חי באמצעות חשיפה מנייתית מבוקרת. רמת סיכון 2 מתוך 5, ומתאים לחוסכים עם אופק השקעה קצר–בינוני.',
            fundIds: [14926,9585, 6, 90, 104, 9456, 13029, 15373]
          },
          {
            key: 'כללי-מנהלי-חול',
            title: `${categoryTitle} - מסלול כללי מנהלי ההשקעות הגדולים בעולם - מסלול חו״ל`,
            description: 'מסלול זה משקיע בשילוב בין נכסים מקומיים וזרים, עם ניהול מקצועי של מנהלים בינלאומיים. המטרה היא לנצל את המומחיות הגלובלית תוך שמירה על איזון בין פוטנציאל תשואה לבין ניהול סיכונים. רמת סיכון 3 מתוך 5, ומתאים לחוסכים עם אופק השקעה בינוני–ארוך.',
            fundIds: [15339, 13644]
          },
          {
            key: 'מניות-מתקדם',
            title: `${categoryTitle} - מסלול מניות מנהלי השקעות הגדולים בעולם - מסלול חו״ל`,
            description: 'מסלול זה מתמחה בהשקעה במניות עם גישה מתקדמת ומקצועית. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך באמצעות בחירה מקצועית של מניות. רמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה ארוך של מעל 5 שנים.',
            fundIds: [15338, 13645]
          },
          {
            key: 'מניות-סחיר',
            title: `${categoryTitle} - מסלול מניות סחיר`,
            description: 'מסלול זה מתמחה בהשקעה במניות סחירות עם נזילות גבוהה. המטרה היא להבטיח יכולת מכירה מהירה תוך שמירה על פוטנציאל תשואה גבוה. רמת סיכון 5 מתוך 5, ומתאים לחוסכים המעוניינים בגמישות השקעה.',
            fundIds: [15319, 12900, 101, 12882, 15443]
          },
          {
            key: 'עוקב-מדדי-מניות',
            title: `${categoryTitle} - מסלול עוקב מדדי מניות`,
            description: 'מסלול זה עוקב אחר מדדי מניות מרכזיים באמצעות ניהול פאסיבי. המטרה היא להשיג תשואות הדומות לביצועי המדדים עם עלויות ניהול נמוכות. רמת סיכון 5 מתוך 5, ומתאים לחוסכים המעוניינים בחשיפה פשוטה ויעילה לשוק המניות.',
            fundIds: [14925, 8572, 14315, 12882, 15029, 14796]
          }
        ];

      case 'insurance-management': // קרנות ביטוח מנהלים
        return [
      {
      key: '50-60',
      title: `${categoryTitle} - מסלול לבני 50 - 60`,
      description: 'ביטוח מנהלים לבני 50-60',
      fundIds: [9593, 9604, 9660, 9670, 12090, 11401, 9563, 11348, 13722, 9630, 9537] // הסרתי כפילויות
    },
{
            key: 'עד-50',
            title: `${categoryTitle} - עד גיל 50`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים עד גיל 50, ומתאפיין בחשיפה גבוהה יחסית למניות – לרוב עד 60% מהנכסים. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך, גם במחיר של תנודתיות גבוהה יותר בטווח הקצר. רמת סיכון 4 מתוך 5, ומתאימה לחוסכים צעירים יחסית, בעלי אופק השקעה ארוך של מעל 5 שנים, המוכנים להתמודד עם ירידות בשוק ההון לטובת תשואה גבוהה בטווח הארוך.',
            fundIds: [9636, 471, 9659, 11341, 13721, 9536, 9599, 9562, 9629, 11400]
          },
     
          {
            key: 'מעל-60',
            title: `${categoryTitle} - מעל גיל 60`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים מגיל 60 ומעלה, ומתאפיין בחשיפה נמוכה יחסית למניות – לרוב עד 25% מהנכסים. המטרה היא לשמור על הון החיסכון לקראת ובמהלך תקופת הפרישה, עם דגש על יציבות והפחתת תנודתיות. רמת סיכון 2 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה בינוני–קצר, המעוניינים בצמיחה מתונה לצד שמירה על חלק ניכר מההון בסיכון נמוך.',
            fundIds: [9671, 9594, 9661, 11349, 9729, 13723, 9544, 11402, 9564, 9631]
          },
  ];
      case 'pension-plans': // קרנות פנסיה
        return [
          {
            key: 'עד-50',
            title: `${categoryTitle} - מסלול לבני 50 ומטה`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים עד גיל 50, ומתאפיין בחשיפה גבוהה יחסית למניות – לרוב עד 60% מהנכסים. המטרה היא למקסם את פוטנציאל הצמיחה לטווח הארוך, גם במחיר של תנודתיות גבוהה יותר בטווח הקצר. רמת סיכון 4 מתוך 5, ומתאימה לחוסכים צעירים יחסית, בעלי אופק השקעה ארוך של מעל 5 שנים, המוכנים להתמודד עם ירידות בשוק ההון לטובת תשואה גבוהה בטווח הארוך.',
            fundIds: [ 9974,2155,9654,8801,9823,9757,13909]
          },
          {
            key: '50-60',
            title: `${categoryTitle} - מסלול לבני 50 עד 60`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים בגילאי 50 עד 60, ומשלב חשיפה מאוזנת בין מניות לאג"ח – לרוב סביב 50% מניות. המטרה היא לאזן בין צמיחת ההון לבין הגנה חלקית מפני תנודתיות גבוהה, בתקופה הקרובה יחסית לגיל הפרישה. רמת סיכון 3 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה בינוני של מספר שנים, המעוניינים לשמור על פוטנציאל תשואה לצד יציבות יחסית.',
            fundIds: [9655, 9967, 9975,8802,9827,9758,13910]
          },
          {
            key: 'מעל-60',
            title: `${categoryTitle} - מסלול לבני 60 ומעלה`,
            description: 'מסלול זה מותאם להנחיות משרד האוצר לחוסכים מגיל 60 ומעלה, ומתאפיין בחשיפה נמוכה יחסית למניות – לרוב עד 25% מהנכסים. המטרה היא לשמור על הון החיסכון לקראת ובמהלך תקופת הפרישה, עם דגש על יציבות והפחתת תנודתיות. רמת סיכון 2 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה בינוני–קצר, המעוניינים בצמיחה מתונה לצד שמירה על חלק ניכר מההון בסיכון נמוך.',
            fundIds: [ 9976,9968,9656,8803,9829,9759,13911]
          },
          {
            key: 'מניות',
            title: `${categoryTitle} - מסלול מניות`,
            description: 'מסלול מניות מיועד לחוסכים שמעוניינים בפוטנציאל תשואה גבוה, ומוכנים להתמודד עם תנודתיות גבוהה לאורך הדרך. המסלול מושקע ברובו במניות, בישראל ובעולם, ונחשב למסלול אגרסיבי עם רמת סיכון גבוהה. רמת סיכון 5 מתוך 5, המקבילה לחוסכים צעירים יחסית, בעלי טווח השקעה ארוך של 5 שנים ויותר.',
            fundIds: [2187,2142,2105,2175,9647, 2063,13912,12419]
          },
          {
            key: 'sp500',
            title: `${categoryTitle} - מסלול מדד S&P 500`,
            description: 'מסלול זה עוקב אחר מדד S&P 500 – הכולל את 500 החברות עם השווי שוק הגדול ביותר בארה"ב. ההשקעה מתבצעת ברובה במניות חו"ל, בדגש על מגזרים מובילים, ולרוב היא חשופה במרבית ההשקעה לדולר האמריקאי. המסלול בעל תנודתיות גבוהה ורמת סיכון 5 מתוך 5, ומתאים לחוסכים עם אופק השקעה ארוך של 5 שנים ומעלה, המוכנים לתנודות חדות בטווח הקצר לטובת פוטנציאל רווח בטווח הארוך.',
            fundIds: [ 13572,13260,13415,13887,13347 ,13335,14850,15266]
          },
          {
            key: 'עוקב-מדדי-מניות',
            title: `${categoryTitle} - עוקב מדדי מניות`,
            description: 'מסלול זה משקיע במניות העוקבות אחר מדדי מניות מובילים בארץ ובעולם, באמצעות ניהול פאסיבי. ההשקעה מתבצעת בעיקר במדדים רחבי היקף, המספקים פיזור בין מגזרים וחברות שונות, ומתמקדת במניות בלבד. רמת סיכון 5 מתוך 5, ומתאימה לחוסכים בעלי אופק השקעה ארוך של 5 שנים ומעלה, המוכנים לתנודתיות גבוהה לטובת פוטנציאל תשואה בטווח הארוך.',
            fundIds: [1589, 15038, 13819,13350,15092,13915,15219]
          },
          {
            key: 'משולב-סחיר',
            title: `${categoryTitle} - משולב סחיר`,
            description: 'מסלול זה משקיע בעיקר בניירות ערך סחירים – מניות ואגרות חוב, בארץ ובעולם, ישירות או באמצעות נגזרים. רמות הסיכון נעות לרוב בין 3 ל־4 מתוך 5, ומתאימות לחוסכים עם טווח השקעה בינוני עד ארוך, המעוניינים בחשיפה לשוק ההון אך לא במסלול מנייתי מלא.',
            fundIds: [14259,14232, 14339,  14277, 14285,14242 , 14302, 14199]
          },
          {
            key: 'אשראי-ואגח',
            title: `${categoryTitle} - אשראי ואג"ח`,
            description: 'מסלול זה משקיע בעיקר באגרות חוב קונצרניות וממשלתיות, וכן בהעמדת אשראי לחברות וגופים מוסדיים. המיקוד באפיקים אלה מאפשר פוטנציאל לתשואה יציבה יחסית, עם תנודתיות נמוכה מאוד בהשוואה למסלולי מניות. רמת סיכון 1 מתוך 5, ומתאימה לחוסכים המעוניינים בהשקעה סולידית במיוחד, תוך חשיפה מזערית או ללא חשיפה למניות.',
            fundIds: [ 2144, 2174, 2188, 13349,13913, 9648,2104]
          },
          {
            key: 'הלכתי',
            title: `${categoryTitle} - הלכתי`,
            description: 'מסלול זה מנוהל בהתאם לכללי ההלכה היהודית, ומסנן השקעות בתחומים שאינם עומדים בקריטריונים ההלכתיים. ההשקעות מתבצעות במניות, אג"ח ונכסים נוספים, בארץ ובעולם, תוך הקפדה על פיקוח הלכתי צמוד. רמות הסיכון משתנות בהתאם להרכב ההשקעות בפועל, אך לרוב נעות סביב 3 מתוך 5, ומתאימות לחוסכים המבקשים לשלב בין השקעה בשוק ההון לבין שמירה על עקרונות ההלכה.',
            fundIds: [9984,2112,2173,2004,2156,9760, 2182,8603]
          }
        ];
       
case 'israeli-stocks': // מסלולים ישראלים - מניות ישראל בלבד
  return [
    {
      key: 'מניות-ישראל-גמל',
      title: 'קופות גמל - מניות ישראל בלבד',
      description: 'קופות גמל המשקיעות רק במניות של חברות ישראליות',
      fundIds: [1036, 761, 877, 1364, 961, 863, 127, 814, 1375, 12531],
      productType: 'pension-savings'
    },
    {
      key: 'מניות-ישראל-השתלמות',
      title: 'קרנות השתלמות - מניות ישראל בלבד',
      description: 'קרנות השתלמות המשקיעות רק במניות של חברות ישראליות',
      fundIds: [883, 968, 869, 1350, 963, 1256, 763, 8563, 1377, 12536],
      productType: 'study-funds'
    },
    {
      key: 'מניות-ישראל-השקעה',
      title: 'גמל השקעה - מניות ישראל בלבד',
      description: 'קופות גמל להשקעה המשקיעות רק במניות של חברות ישראליות',
      fundIds: [8522, 7860, 7975, 7934, 7836, 7991, 7799, 11394, 12537],
      productType: 'investment-funds'
    },
    {
      key: 'מניות-ישראל-פנסיה',
      title: 'קרנות פנסיה - מניות ישראל בלבד',
      description: 'קרנות פנסיה המשקיעות רק במניות של חברות ישראליות',
      fundIds: [2187, 2142, 2105, 2175, 9647, 2063, 12419],
      productType: 'pension-plans'
    }
  ];

case 'foreign-stocks': // מסלולים מניותיים - חו"ל בלבד
  return [
    {
      key: 'sp500-השתלמות',
      title: 'קרנות השתלמות - S&P 500',
      description: 'קרנות השתלמות העוקבות אחר מדד S&P 500',
      fundIds: [14862, 13853, 13342, 14668, 13873, 13502, 13264, 13245, 9451, 14849],
      productType: 'study-funds'
    },
    {
      key: 'sp500-גמל',
      title: 'קופות גמל - S&P 500',
      description: 'קופות גמל העוקבות אחר מדד S&P 500',
      fundIds: [14858, 15419, 13855, 13946, 13501, 13263, 13246, 9452, 13343, 13565],
      productType: 'pension-savings'
    },
    {
      key: 'sp500-השקעה',
      title: 'גמל השקעה - S&P 500',
      description: 'קופות גמל להשקעה העוקבות אחר S&P 500',
      fundIds: [13259, 13250, 7958, 13344, 13563, 14865, 13874, 13854, 13414, 15420],
      productType: 'investment-funds'
    },
    {
      key: 'sp500-פנסיה',
      title: 'קרנות פנסיה - S&P 500',
      description: 'קרנות פנסיה העוקבות אחר מדד S&P 500',
      fundIds: [13572, 13260, 13415, 13887, 13347, 13335, 14850, 15266],
      productType: 'pension-plans'
    },
    {
      key: 'sp500-ביטוח',
      title: 'פוליסות חיסכון - S&P 500',
      description: 'פוליסות המשקיעות במדד S&P 500',
      fundIds: [9554, 13346, 13434, 13625, 14169, 14316, 15062, 15108],
      productType: 'insurance-savings'
    },
    {
      key: 'מדדי-עולם-מעורב',
      title: 'מדדי עולם - מעורב',
      description: 'קרנות העוקבות אחר מדדי מניות עולמיים מסוגים שונים',
      fundIds: [1589, 15038, 13819, 13350, 15092, 13915, 15219, 15311, 11408, 481, 15028, 7256],
      productType: 'mixed'
    },
    {
      key: 'נאסדק-וטכנולוגיה-מעורב',
      title: 'נאסד"ק וטכנולוגיה - מעורב',
      description: 'קרנות המתמחות במניות טכנולוגיה ונאסד"ק',
      fundIds: [14657, 8629, 14680, 15239, 15297, 14293, 14201, 14265],
      productType: 'mixed'
    }
  ];

case 'mixed-global': // מבולבלים כלליים - פיזור גלובלי
  return [
    {
      key: 'כללי-מאוזן-השתלמות',
      title: 'קרנות השתלמות - כלליות מאוזנות',
      description: 'קרנות השתלמות מגוונות המשלבים מניות ואג"ח',
      fundIds: [962, 964, 880, 12535, 456, 1162, 579, 1093, 828, 154],
      productType: 'study-funds'
    },
    {
      key: 'כללי-מאוזן-השקעה',
      title: 'גמל השקעה - כלליות מאוזנות',
      description: 'קופות גמל להשקעה מגוונות המשלבים מניות ואג"ח',
      fundIds: [11390, 8675, 7798, 8211, 7908],
      productType: 'investment-funds'
    },
    {
      key: 'משולב-סחיר-השתלמות',
      title: 'קרנות השתלמות - משולב סחיר',
      description: 'קרנות השתלמות משולבות עם נכסים סחירים',
      fundIds: [15458, 8779, 15426, 15235, 15448, 15466, 1034, 15211, 15355],
      productType: 'study-funds'
    },
    {
      key: 'משולב-סחיר-גמל',
      title: 'קופות גמל - משולב סחיר',
      description: 'קופות גמל משולבות עם נכסים סחירים',
      fundIds: [14292, 14202, 14264, 14271, 14353],
      productType: 'pension-savings'
    },
    {
      key: 'גילאים-מאוזן-גמל',
      title: 'קופות גמל - מסלולים לפי גילאים',
      description: 'קופות גמל מאוזנות המיועדים לגילאים שונים',
      fundIds: [9730, 12532, 7215, 9916, 9651, 9779, 9793, 9939, 9744, 9950],
      productType: 'pension-savings'
    }
  ];

case 'stocks-global': // מסלולים מניותיים - פיזור גלובלי
  return [
    {
      key: 'מניות-פעיל-השתלמות',
      title: 'קרנות השתלמות - מניות בניהול פעיל',
      description: 'קרנות השתלמות בניהול פעיל המשקיעות במניות גלובליות',
      fundIds: [12536, 883, 968, 869, 1350, 963, 1256, 763, 8563, 1377],
      productType: 'study-funds'
    },
    {
      key: 'מניות-פעיל-גמל',
      title: 'קופות גמל - מניות בניהול פעיל',
      description: 'קופות גמל בניהול פעיל המשקיעות במניות גלובליות',
      fundIds: [1036, 761, 877, 1364, 961],
      productType: 'pension-savings'
    },
    {
      key: 'מניות-פעיל-השקעה',
      title: 'גמל השקעה - מניות בניהול פעיל',
      description: 'קופות גמל להשקעה בניהול פעיל למניות גלובליות',
      fundIds: [12537, 8522, 7860, 7975, 7934, 7836, 11394, 7991, 7799],
      productType: 'investment-funds'
    },
    {
      key: 'מדדים-גמישים-מעורב',
      title: 'עוקבי מדדים גמישים - מעורב',
      description: 'קרנות העוקבות אחר מדדי מניות בגמישות וניהול דינמי',
      fundIds: [15311, 11408, 481, 15028, 7256, 14657, 8629, 14680, 15239, 15297],
      productType: 'mixed'
    }
  ];

case 'solid-shekel': // מסלולים סולידיים - פקדונות ושקליים
  return [
    {
      key: 'אגח-ממשלתיות-השתלמות',
      title: 'קרנות השתלמות - אג"ח ממשלתיות',
      description: 'קרנות השתלמות המשקיעות באג"ח ממשלתיות בשקלים',
      fundIds: [1399, 973, 865, 1387, 1361],
      productType: 'study-funds'
    },
    {
      key: 'אגח-ממשלתיות-גמל',
      title: 'קופות גמל - אג"ח ממשלתיות',
      description: 'קופות גמל המשקיעות באג"ח ממשלתיות בשקלים',
      fundIds: [1360, 1386, 15343, 1395, 859, 1412],
      productType: 'pension-savings'
    },
    {
      key: 'אשראי-ואגח-השתלמות',
      title: 'קרנות השתלמות - אשראי ואג"ח',
      description: 'קרנות השתלמות המשקיעות באשראי ואג"ח של חברות ישראליות',
      fundIds: [14483, 716, 1319, 972, 13357, 1348, 1240, 199, 1485, 1378],
      productType: 'study-funds'
    },
    {
      key: 'אשראי-ואגח-גמל',
      title: 'קופות גמל - אשראי ואג"ח',
      description: 'קופות גמל המשקיעות באשראי ואג"ח של חברות ישראליות',
      fundIds: [1037, 1335, 1376],
      productType: 'pension-savings'
    },
    {
      key: 'מעל-60-שמרני-גמל',
      title: 'קופות גמל - מסלולים לגיל 60+ שמרניים',
      description: 'קופות גמל שמרניות המיועדים לגיל פרישה',
      fundIds: [9941, 9745, 551, 9794, 401, 9781, 9732, 12534, 9952],
      productType: 'pension-savings'
    },
    {
      key: 'מעל-60-שמרני-פנסיה',
      title: 'קרנות פנסיה - מסלולים לגיל 60+ שמרניים',
      description: 'קרנות פנסיה שמרניות המיועדים לגיל פרישה',
      fundIds: [9976, 9968, 9656],
      productType: 'pension-plans'
    },
    {
      key: 'פוליסות-שמרניות',
      title: 'פוליסות חיסכון שמרניות',
      description: 'פוליסות חיסכון עם השקעות שמרניות בשקלים',
      fundIds: [4, 98, 114, 42, 47, 89, 8659, 14425, 116, 108],
      productType: 'insurance-savings'
    }
  ];
      default:
        return [
          {
            key: 'כללי',
            title: `${categoryTitle} - כללי`,
            description: 'קרנות כלליות',
            fundIds: []
          }
        ];
    }
  };
  
  /**
   * 🎯 פונקציות עזר נוספות
   */
  
  // קבלת קרנות מובילות לפי קטגוריה

  
  // קבלת כל ההתמחויות לקטגוריה
  export const getAllSpecializationsForCategory = (category, categoryTitle = '') => {
    return getSpecializationConfigs(category, categoryTitle);
  };
  
  // קבלת התמחות ספציפית
  export const getSpecializationById = (category, specializationKey, categoryTitle = '') => {
    const specializations = getSpecializationConfigs(category, categoryTitle);
    return specializations.find(spec => spec.key === specializationKey);
  };
  
  // קבלת רשימת כל המזהים לקטגוריה (מכל ההתמחויות)
  export const getAllFundIdsForCategory = (category) => {
    const specializations = getSpecializationConfigs(category, '');
    const allIds = new Set();
    
    specializations.forEach(spec => {
      spec.fundIds.forEach(id => allIds.add(id));
    });
    
    return Array.from(allIds);
  };
  
  // מציאת קטגוריה של מזהה קרן
// הוסף פונקציה חדשה בסוף הקובץ:
export const getCategoryTitle = (categoryId) => {
const categoryTitles = {
  'israeli-stocks': 'מסלולים ישראלים - מניות ישראל בלבד',
  'foreign-stocks': 'מסלולים מניותיים - חו"ל בלבד', 
  'mixed-global': 'מבולבלים כלליים - פיזור גלובלי',
  'stocks-global': 'מסלולים מניותיים - פיזור גלובלי',
  'solid-shekel': 'מסלולים סולידיים - פקדונות ושקליים בלבד',
  'study-funds': 'קרנות השתלמות',
  'pension-savings': 'קופות גמל',
  'investment-funds': 'קופות גמל להשקעה',
  'child-savings': 'תוכנית חיסכון לכל ילד',
  'insurance-savings': 'פוליסות חיסכון',
  'insurance-management': 'קרנות ביטוח מנהלים', // הוסף את השורה הזו
  'pension-plans': 'קרנות פנסיה'
};
  
  return categoryTitles[categoryId] || categoryId;
};

// 🆕 הוסף את הפונקציות האלה בסוף fundConfigurations.js

/**
 * 🎯 בניית השוואה דינמית לפי רמת סיכון
 * פונקציה זו נקראת כשהמוצר לא נמצא ברשימות המוכנות מראש
 */
export const buildDynamicComparisonByRiskLevel = async (currentProduct, categoryId, apiService) => {
  try {
    console.log(`🎯 Building dynamic comparison for product ${currentProduct.id}, risk level: ${currentProduct.riskLevel?.level}`);
    
    const currentRiskLevel = currentProduct.riskLevel?.level;
    
    // אם אין רמת סיכון - fallback למנגנון הישן
    if (!currentRiskLevel || currentRiskLevel === 0) {
      console.warn(`⚠️ No risk level found for product ${currentProduct.id}, using fallback`);
      return buildFallbackComparison(currentProduct, categoryId);
    }

    // טען את כל מוצרי הקטגוריה
    const categoryProducts = await apiService.getProductsByCategory(categoryId, { limit: 5000 });
    
    // סנן רק מוצרים עם אותה רמת סיכון שפעילים
    const sameRiskProducts = categoryProducts.filter(product => 
      product.riskLevel?.level === currentRiskLevel && 
      product.isActive !== false &&
      product.id !== currentProduct.id
    );

    console.log(`🔍 Found ${sameRiskProducts.length} products with same risk level ${currentRiskLevel}`);

    if (sameRiskProducts.length === 0) {
      console.warn(`⚠️ No products found with risk level ${currentRiskLevel}, expanding search`);
      return expandRiskLevelSearch(currentProduct, categoryId, categoryProducts);
    }

    // דרג לפי רלוונטיות (שם + ביצועים)
    const scoredProducts = sameRiskProducts.map(product => ({
      product,
      score: calculateRelevanceScore(currentProduct, product)
    }));

    // מיון לפי ציון רלוונטיות
    scoredProducts.sort((a, b) => b.score - a.score);

    // קח את 10 הטובים ביותר + המוצר הנוכחי
    const topProducts = scoredProducts.slice(0, 9).map(item => item.product);
    const finalProductIds = [parseInt(currentProduct.id), ...topProducts.map(p => parseInt(p.id))];

    const result = {
      key: `dynamic-risk-${currentRiskLevel}`,
      title: `השוואה חכמה - רמת סיכון ${currentRiskLevel} כוכבים`,
      description: `מוצרים באותה רמת סיכון (${getRiskLevelName(currentRiskLevel)}) מהקטגוריה`,
      fundIds: finalProductIds,
      isDynamic: true,
      riskLevel: currentRiskLevel,
      matchingMethod: 'risk-level-based'
    };

    logComparisonFundIds(result.key, result.fundIds);

    console.log(`✅ Dynamic comparison built:`, result);
    return result;

  } catch (error) {
    console.error('❌ Error building dynamic comparison:', error);
    return buildFallbackComparison(currentProduct, categoryId);
  }
};

/**
 * 🔍 חיפוש מורחב כשאין מוצרים באותה רמת סיכון
 */
const expandRiskLevelSearch = (currentProduct, categoryId, allProducts) => {
  const currentRiskLevel = currentProduct.riskLevel?.level || 3;
  
  // חפש ברמות סיכון סמוכות (±1)
  const nearbyRiskLevels = [
    currentRiskLevel - 1,
    currentRiskLevel,
    currentRiskLevel + 1
  ].filter(level => level >= 1 && level <= 5);

  console.log(`🔍 Expanding search to risk levels: ${nearbyRiskLevels.join(', ')}`);

  const expandedProducts = allProducts.filter(product => 
    nearbyRiskLevels.includes(product.riskLevel?.level) && 
    product.isActive !== false &&
    product.id !== currentProduct.id
  );

  // אם עדיין אין מספיק, קח את הטובים בקטגוריה
  if (expandedProducts.length < 5) {
    console.log(`🔍 Still not enough products, taking best in category`);
    const bestInCategory = allProducts
      .filter(product => 
        product.isActive !== false &&
        product.id !== currentProduct.id &&
        product.returns?.year1 != null
      )
      .sort((a, b) => (b.returns?.year1 || 0) - (a.returns?.year1 || 0))
      .slice(0, 9);

    const result = {
      key: `dynamic-category-${categoryId}`,
      title: `השוואה חכמה - מובילות בקטגוריה`,
      description: `המוצרים המובילים בקטגוריה (לא נמצאו מספיק מוצרים ברמת סיכון דומה)`,
      fundIds: [parseInt(currentProduct.id), ...bestInCategory.map(p => parseInt(p.id))],
      isDynamic: true,
      riskLevel: null,
      matchingMethod: 'category-best'
    };

    logComparisonFundIds(result.key, result.fundIds);

    return result;
  }

  // דרג את המוצרים המורחבים
  const scoredProducts = expandedProducts.map(product => ({
    product,
    score: calculateRelevanceScore(currentProduct, product)
  }));

  scoredProducts.sort((a, b) => b.score - a.score);
  const topProducts = scoredProducts.slice(0, 9).map(item => item.product);

  const result = {
    key: `dynamic-risk-expanded-${currentRiskLevel}`,
    title: `השוואה חכמה - רמות סיכון דומות`,
    description: `מוצרים ברמות סיכון דומות (${nearbyRiskLevels.join(', ')} כוכבים)`,
    fundIds: [parseInt(currentProduct.id), ...topProducts.map(p => parseInt(p.id))],
    isDynamic: true,
    riskLevel: currentRiskLevel,
    matchingMethod: 'risk-level-expanded'
  };

  logComparisonFundIds(result.key, result.fundIds);

  return result;
};


/**
 * חישוב דמיון בין שמות מוצרים
 */
const calculateNameSimilarity = (name1, name2) => {
  const keywords1 = extractKeywords(name1);
  const keywords2 = extractKeywords(name2);
  const commonKeywords = keywords1.filter(keyword => keywords2.includes(keyword));
  const totalKeywords = new Set([...keywords1, ...keywords2]).size;
  return totalKeywords > 0 ? commonKeywords.length / totalKeywords : 0;
};


/**
 * חילוץ מילות מפתח משם המוצר - גרסה מתוקנת
 * הפונקציה תזהה צירופי מילים כמו "מניות סחיר" ולא רק מילים בודדות
 */
const extractKeywords = (productName) => {
  const name = productName.toLowerCase();
  
  // רשימת צירופי מילים (בסדר חשיבות - הארוכים קודם)
  const keywordCombinations = [
    // צירופי מילים של 4+ מילים - הכי ספציפיים
    'עוקב מדדי אגח עם מניות',
    'עוקב מדדים עוקב מדדי אגח',
    
    // צירופי מילים של 3+ מילים
    'עוקב מדדי מניות',         // 🆕 הוספה - ספציפי ביותר
    'עוקב מדדי אגח',           // 🆕 הוספה - לעתיד
    'מניות סחיר ישראל',
    'אגח ממשלתיות ישראל',
    'עוקב מדדים גמיש',
    'אשראי ואגח עד 25',
    'מניות ישראל בלבד',
    'עד 25% מניות',              // 🆕 הוספה - זיהוי הגבלת מניות
    'עד 25 מניות',                // 🆕 הוספה - זיהוי הגבלת מניות (בלי %)
    'אגח עם מניות',              // 🆕 הוספה - זיהוי אגח עם מניות

    
    // צירופי מילים של 2 מילים
    'עוקב מדדי',  
    'מניות סחיר',
    'משולב סחיר',
    'עוקב מדדים',
    'אגח ממשלתיות',
    'אשראי ואגח',
    'מניות ישראל',
    'מניות חול',
    'sp 500',
    's&p 500',
    'הלכתי יהודי',
    'הלכתי איסלאמי',
    'מדד שפ',
    'מדד נאסדק',
    
    // מילים בודדות - רק אם לא נמצא צירוף מילים
    'כללי', 'מאוזן', 'מניות', 'אגח', 'ממשלתיות', 'אשראי',
    'sp500', 's&p', '500', 'nasdaq', 'נאסדק',
    'הלכתי', 'שריעה', 'שרעי', 'עוקב', 'מדד', 'משולב', 'סחיר',
    'הלכה',
    'צעיר', 'בוגר', 'וותיק', 'גיל', 'פעיל', 'ישראל', 'חול'
  ];
  
  const foundKeywords = [];
  
  // חפש צירופי מילים ומילים בודדות בסדר חשיבות
  for (const keyword of keywordCombinations) {
    if (name.includes(keyword)) {
      foundKeywords.push(keyword);
    }
  }
  
  // הסר כפילויות ותן עדיפות לצירופי מילים על פני מילים בודדות
  const uniqueKeywords = [];
  const addedWords = new Set();
  
  for (const keyword of foundKeywords) {
    // בדוק אם זה צירוף מילים
    if (keyword.includes(' ')) {
      uniqueKeywords.push(keyword);
      // סמן את המילים הבודדות כמוספות כדי למנוע כפילות
      keyword.split(' ').forEach(word => addedWords.add(word.trim()));
    } else if (!addedWords.has(keyword)) {
      uniqueKeywords.push(keyword);
      addedWords.add(keyword);
    }
  }
  
  console.log(`🔤 Extracted keywords from "${productName}": ${uniqueKeywords.join(', ')}`);
  return uniqueKeywords;
};


/**
 * חישוב דמיון חשיפות
 */
const calculateExposureSimilarity = (product1, product2) => {
  const fields = ['stocks', 'foreign', 'currency'];
  let totalScore = 0;
  let validFields = 0;

  fields.forEach(field => {
    const val1 = product1.exposures?.[field] || 0;
    const val2 = product2.exposures?.[field] || 0;
    if (val1 || val2) {
      const diff = Math.abs(val1 - val2);
      const similarity = Math.max(0, 1 - diff / 100);
      totalScore += similarity;
      validFields++;
    }
  });

  return validFields > 0 ? totalScore / validFields : 0;
};

/**
 * 🏷️ קבלת שם רמת סיכון
 */
const getRiskLevelName = (level) => {
  const names = {
    1: 'סולידי קלאסי',
    2: 'סולידי-מאוזן', 
    3: 'כללי מאוזן',
    4: 'מניתי מאוזן',
    5: 'מניתי מלא'
  };
  return names[level] || `רמה ${level}`;
};

/**
 * 🚨 Fallback - מקרה שהמערכת החכמה נכשלה
 */
const buildFallbackComparison = (currentProduct, categoryId) => {
  console.log(`🚨 Using fallback comparison for product ${currentProduct.id}`);
  
  // החזר התמחות כללית או השתמש במנגנון הישן
  const specializations = getSpecializationConfigs(categoryId);
  const firstSpec = specializations[0];
  
  if (firstSpec) {
    const result = {
      ...firstSpec,
      fundIds: [parseInt(currentProduct.id), ...firstSpec.fundIds.slice(0, 9)],
      isDynamic: true,
      matchingMethod: 'fallback'
    };

    logComparisonFundIds(result.key || 'fallback', result.fundIds);

    return result;
  }

  const minimalResult = {
    key: 'fallback',
    title: 'השוואה בסיסית',
    description: 'השוואה בסיסית - לא נמצאה התאמה מתאימה',
    fundIds: [parseInt(currentProduct.id)],
    isDynamic: true,
    matchingMethod: 'minimal'
  };

  logComparisonFundIds(minimalResult.key, minimalResult.fundIds);

  return minimalResult;
};
const identifyPensionType = (product) => {
  // קודם בדוק את השדות החדשים מה-API
  if (product.isComplementaryPension === true) {
    return 'supplementary';
  }
  
  if (product.isComprehensivePension === true) {
    return 'comprehensive';
  }
  
  // אם אין שדות API, נסה לזהות לפי השם (fallback)
  const name = product.name ? product.name.toLowerCase() : '';
  
  const supplementaryKeywords = [
    'משלימה', 'משלים', 'supplementary', 'נוספת', 'תוספת'
  ];
  
  if (supplementaryKeywords.some(keyword => name.includes(keyword))) {
    return 'supplementary';
  }
  
  // ברירת מחדל - רוב הקרנות הן מקיפות
  return 'comprehensive';
};
export const getEnhancedSpecializationMatch = async (currentProduct, categoryId, apiService) => {
  try {
    // console.log(`🔍 Enhanced matching for product: ${currentProduct.name}, ID: ${currentProduct.id}, categoryId: ${categoryId}`);
    
    // שלב 1: בדיקה אם הקרן קיימת ברשימות המוכנות (ללא שינוי)
    const specializations = getSpecializationConfigs(categoryId);
    const currentProductId = parseInt(currentProduct.id);
    
    const directMatch = specializations.find(spec => 
      spec.fundIds.includes(currentProductId)
    );
    
    if (directMatch) {
      // console.log(`✅ Found direct match in specialization: ${directMatch.key}`);
      const result = {
        ...directMatch,
        fundIds: [currentProductId, ...directMatch.fundIds.filter(id => id !== currentProductId).slice(0, 9)],
        isDynamic: false,
        matchingMethod: 'direct'
      };

      logComparisonFundIds(result.key || 'direct-match', result.fundIds);

      return result;
    }
const hiddenMatch = specializations.find(spec => 
  spec.hiddenFundIds?.includes(currentProductId)
);

if (hiddenMatch) {
  console.log(`✅ Found hidden match in specialization: ${hiddenMatch.key}`);
  const result = {
    ...hiddenMatch,
    fundIds: [currentProductId, ...hiddenMatch.fundIds.slice(0, 9)], // רק המוצר הנוכחי + הרגילים
    isDynamic: false,
    matchingMethod: 'hidden'
  };

  logComparisonFundIds(result.key || 'hidden-match', result.fundIds);

  return result;
}
    // **שלב 2 החדש: הבחנה מיוחדת עבור קרנות פנסיה**
    if (categoryId === 'pension-plans') {
      console.log(`🏦 Applying pension-specific logic`);
      return await buildPensionSpecificComparison(currentProduct, apiService);
    }

    // שלב 3: חיפוש התמחות לפי מילות מפתח בשם (ללא שינוי)
    console.log(`🎯 No direct match found, checking for specialization by name keywords`);
    const keywords = extractKeywords(currentProduct.name);
    const matchingSpecialization = specializations.find(spec => 
      keywords.includes(spec.key)
    );

    if (matchingSpecialization) {
      console.log(`✅ Found specialization match by name: ${matchingSpecialization.key}`);
      const result = {
        ...matchingSpecialization,
        fundIds: [currentProductId, ...matchingSpecialization.fundIds.slice(0, 9)],
        isDynamic: false,
        matchingMethod: 'specialization-key'
      };

      logComparisonFundIds(result.key || 'specialization-key', result.fundIds);

      return result;
    }

    // שלב 4: השוואה דינמית רגילה (ללא שינוי)
    console.log(`🎯 No specialization match found, building dynamic comparison`);
    return await buildDynamicComparisonByRiskLevelAndName(currentProduct, categoryId, apiService);
    
  } catch (error) {
    console.error('❌ Error in enhanced matching:', error);
    return buildFallbackComparison(currentProduct, categoryId);
  }
};
function extractAgeRange(productName) {
  // זיהוי "60 ומעלה" עם וריאציות
  if (/60\s*ומעלה|60\s*\+|מעל\s*60|60\s*ומטה|לבני\s*60\s*ומעלה/i.test(productName)) {
    return { min: 60, max: Infinity, label: '60+' };
  }
  
  // זיהוי "50 עד 60" עם וריאציות
  if (/50\s*עד\s*60|50\s*-\s*60|לבני\s*50\s*עד\s*60|בני\s*50\s*-\s*60/i.test(productName)) {
    return { min: 50, max: 60, label: '50-60' };
  }
  
  // זיהוי "עד 50" / "50 ומטה"
  if (/עד\s*50|50\s*ומטה|50\s*-|לבני\s*50|בני\s*50\s*ומטה/i.test(productName)) {
    return { min: 0, max: 50, label: '0-50' };
  }
  
  return null;
}
const identifyPrimarySpecialization = (keywords) => {
  console.log(`🔍 Analyzing keywords: ${keywords.join(', ')}`);
  
  // הסדר הנכון: ההתמחויות הספציפיות ביותר קודם!
  const specializationHierarchy = [
    // ספציפי ביותר: צירופי מילים של מדדים
    { 
      keywords: ['עוקב', 'מדד'], 
      specialization: 'index-tracking',
      requiresBoth: true  // דרוש שניהם יחד
    },
    { 
      keywords: ['עוקב מדדים גמיש', 'מדדים גמיש'], 
      specialization: 'flexible-index' 
    },
    { 
      keywords: ['sp 500', 's&p 500', 'sp500'], 
      specialization: 'sp500' 
    },
    { 
      keywords: ['משולב סחיר'], 
      specialization: 'tradable-mixed' 
    },
    { 
      keywords: ['מניות סחיר'], 
      specialization: 'tradable-stocks' 
    },
    { 
      keywords: ['אשראי ואגח'], 
      specialization: 'credit-bonds' 
    },
    { 
      keywords: ['אגח ממשלתיות'], 
      specialization: 'government-bonds' 
    },
       { 
      keywords: ['הלכתי','הלכה', 'שריעה', 'שרעי', 'halal', 'kosher', 'religious'], 
      specialization: 'halachic' 
    },
  
    // כללי ביותר - רק אם אין התמחות ספציפית
    { 
      keywords: ['מניות'], 
      specialization: 'stocks' 
    },
    { 
      keywords: ['כללי', 'מאוזן'], 
      specialization: 'general' 
    }
  ];

  // חפש את ההתמחות הספציפית ביותר
  for (const item of specializationHierarchy) {
    if (item.requiresBoth) {
      // בדוק שכל המילים הנדרשות קיימות
      if (item.keywords.every(keyword => keywords.includes(keyword))) {
        console.log(`🎯 Found SPECIFIC specialization: ${item.specialization} (requires all: ${item.keywords.join(' + ')})`);
        return item.specialization;
      }
    } else {
      // בדוק אם קיימת לפחות אחת מהמילים
      if (item.keywords.some(keyword => keywords.includes(keyword))) {
        console.log(`🎯 Found specialization: ${item.specialization} for keywords: ${keywords.join(', ')}`);
        return item.specialization;
      }
    }
  }

  console.log(`⚠️ No specific specialization found, defaulting to general`);
  return 'general';
};
const buildPensionSpecificComparison = async (currentProduct, apiService) => {
  try {
const pensionType = identifyPensionType(currentProduct); // העבר את כל האובייקט

    const currentRiskLevel = currentProduct.riskLevel?.level;
    
    console.log(`🏦 Pension type: ${pensionType}, risk level: ${currentRiskLevel}`);
    
    // טען את כל קרנות הפנסיה
    const allPensionFunds = await apiService.getProductsByCategory('pension-plans', { limit: 5000 });
    
    // סינון ראשון: אותו סוג פנסיה + אותה רמת סיכון
// סינון ראשון: אותו סוג פנסיה + אותה רמת סיכון + התמחות דומה
if (pensionType !== 'unknown') {
  const currentKeywords = extractKeywords(currentProduct.name);
  const primarySpecialization = identifyPrimarySpecialization(currentKeywords);
  
  console.log(`🔍 Primary specialization: ${primarySpecialization}`);
  
  const sameTypeFunds = allPensionFunds.filter(fund => {
    const fundKeywords = extractKeywords(fund.name);
    const fundSpecialization = identifyPrimarySpecialization(fundKeywords);
    
    return identifyPensionType(fund) === pensionType &&
           fund.riskLevel?.level === currentRiskLevel &&
           fundSpecialization === primarySpecialization && // 🆕 התמחות זהה
           fund.isActive !== false &&
           fund.id !== currentProduct.id;
  });
      
      if (sameTypeFunds.length > 0) {
        console.log(`✅ Found ${sameTypeFunds.length} same type (${pensionType}) funds`);
        
        // דרג לפי רלוונטיות
        const scoredFunds = sameTypeFunds.map(fund => ({
          product: fund,
          score: calculateRelevanceScore(currentProduct, fund) + 25 // בונוס לאותו סוג
        }));
        
        scoredFunds.sort((a, b) => b.score - a.score);
        const topFunds = scoredFunds.slice(0, 9).map(item => item.product);
        
        const pensionTypeHebrew = pensionType === 'comprehensive' ? 'מקיפה' : 'משלימה';
        
        const result = {
          key: `pension-${pensionType}-risk-${currentRiskLevel}`,
          title: `קרנות פנסיה ${pensionTypeHebrew} - רמת סיכון ${currentRiskLevel} כוכבים`,
          description: `השוואה בין קרנות פנסיה ${pensionTypeHebrew} עם רמת סיכון זהה של ${currentRiskLevel} כוכבים`,
          fundIds: [parseInt(currentProduct.id), ...topFunds.map(f => parseInt(f.id))],
          isDynamic: true,
          pensionType: pensionType,
          riskLevel: currentRiskLevel,
          matchingMethod: 'pension-type-and-risk'
        };

        logComparisonFundIds(result.key, result.fundIds);
        
        return result;
      }
    }
    
    // סינון שני: כל קרנות הפנסיה באותה רמת סיכון
    console.log(`⚠️ No same-type funds found, expanding to all pension funds with same risk level`);
    
    const sameRiskFunds = allPensionFunds.filter(fund =>
      fund.riskLevel?.level === currentRiskLevel &&
      fund.isActive !== false &&
      fund.id !== currentProduct.id
    );
    
    if (sameRiskFunds.length === 0) {
      console.warn(`⚠️ No pension funds found with risk level ${currentRiskLevel}`);
      const result = {
        key: `pension-no-match-risk-${currentRiskLevel}`,
        title: `קרנות פנסיה - רמת סיכון ${currentRiskLevel} כוכבים`,
        description: `לא נמצאו קרנות פנסיה נוספות עם רמת סיכון ${currentRiskLevel} כוכבים`,
        fundIds: [parseInt(currentProduct.id)],
        isDynamic: true,
        pensionType: pensionType,
        riskLevel: currentRiskLevel,
        matchingMethod: 'pension-no-match'
      };

      logComparisonFundIds(result.key, result.fundIds);

      return result;
    }
    
    // דרג לפי רלוונטיות
    const scoredFunds = sameRiskFunds.map(fund => ({
      product: fund,
      score: calculateRelevanceScore(currentProduct, fund)
    }));
    
    scoredFunds.sort((a, b) => b.score - a.score);
    const topFunds = scoredFunds.slice(0, 9).map(item => item.product);
    
    const result = {
      key: `pension-all-risk-${currentRiskLevel}`,
      title: `קרנות פנסיה - רמת סיכון ${currentRiskLevel} כוכבים`,
      description: `השוואה בין כל קרנות הפנסיה עם רמת סיכון ${currentRiskLevel} כוכבים (לא נמצאו מספיק קרנות מאותו סוג)`,
      fundIds: [parseInt(currentProduct.id), ...topFunds.map(f => parseInt(f.id))],
      isDynamic: true,
      pensionType: pensionType,
      riskLevel: currentRiskLevel,
      matchingMethod: 'pension-all-same-risk'
    };

    logComparisonFundIds(result.key, result.fundIds);
    
    return result;
    
  } catch (error) {
    console.error('❌ Error in pension-specific comparison:', error);
    // fallback לשימוש בלוגיקה הרגילה
    return await buildDynamicComparisonByRiskLevelAndName(currentProduct, 'pension-plans', apiService);
  }
};
/**
 * חיפוש דינמי לפי סוג, רמת סיכון ומילת מפתח בשם
 * @param {Object} currentProduct - אובייקט הקרן הנוכחית
 * @param {string} categoryId - מזהה הקטגוריה
 * @param {Object} apiService - שירות API לקבלת נתוני קרנות
 * @returns {Object} - תוצאת השוואה דינמית
 */

function doAgeRangesMatch(range1, range2) {
  if (!range1 || !range2) return false;
  return range1.label === range2.label;
}

// 🔧 העדכון העיקרי: הוסף סינון לפי גיל לפונקציה הדינמית
const buildDynamicComparisonByRiskLevelAndName = async (currentProduct, categoryId, apiService) => {
  try {
    const riskLevel = currentProduct.riskLevel?.level || 3;
    const keywords = extractKeywords(currentProduct.name);
    
    // 🆕 חלץ את טווח הגיל של הקרן הנוכחית
    const currentAgeRange = extractAgeRange(currentProduct.name);
    
    // 🔍 בחירת מילת מפתח ראשית - תעדיף צירופי מילים ספציפיים
    const primaryKeyword = keywords.find(keyword => 
      // צירופי מילים ספציפיים ביותר - קודם כל
      ['עוקב מדדי אגח עם מניות', 'עד 25% מניות', 'עד 25 מניות', 'אגח עם מניות'].includes(keyword)
    ) || keywords.find(keyword => 
      // צירופי מילים בינוניים
      ['מניות סחיר', 'משולב סחיר', 'עוקב מדדים', 'עוקב מדדי', 'אגח ממשלתיות', 'אשראי ואגח'].includes(keyword)
    ) || keywords.find(keyword =>
      // מילים בודדות - רק אם לא מצאנו צירוף מילים
      ['הלכתי', 'מניות', 'אגח', 'sp500', 'כללי'].includes(keyword)
    ) || keywords[0] || 'כללי';

    console.log(`🔍 STRICT comparison: category ${categoryId}, EXACT risk level ${riskLevel}, keyword "${primaryKeyword}", age range: ${currentAgeRange?.label || 'none'}`);

    // טען את כל מוצרי הקטגוריה
    const categoryProducts = await apiService.getProductsByCategory(categoryId, { limit: 5000 });

    // 🆕 סינון מחמיר: רק אותה רמת סיכון + אותו טווח גיל (אם קיים)
    const exactRiskProducts = categoryProducts.filter(product => {
      // תנאי 1: רמת סיכון זהה
      if (product.riskLevel?.level !== riskLevel) return false;
      
      // תנאי 2: מוצר פעיל
      if (product.isActive === false) return false;
      
      // תנאי 3: לא המוצר הנוכחי
      if (product.id === currentProduct.id) return false;
      
      // 🆕 תנאי 4: טווח גיל תואם (אם קיים טווח גיל במוצר הנוכחי)
      if (currentAgeRange) {
        const productAgeRange = extractAgeRange(product.name);
        console.log(`🔤 Extracted keywords from "${product.name}": ${productAgeRange?.label || 'none'}`);
        
        // אם למוצר הנוכחי יש טווח גיל, דרוש שגם למוצר המושווה יהיה אותו טווח
        if (!doAgeRangesMatch(currentAgeRange, productAgeRange)) {
          return false;
        }
      }
      
      return true;
    });

    console.log(`📊 Found ${exactRiskProducts.length} products with EXACT risk level ${riskLevel}${currentAgeRange ? ` and age range ${currentAgeRange.label}` : ''}`);

    // אם אין קרנות באותה רמת סיכון וטווח גיל - החזר רק את הקרן הנוכחית
    if (exactRiskProducts.length === 0) {
      console.warn(`⚠️ No funds found with EXACT risk level ${riskLevel}${currentAgeRange ? ` and age range ${currentAgeRange.label}` : ''} - returning only current fund`);
      const result = {
        key: `no-match-risk-${riskLevel}${currentAgeRange ? `-age-${currentAgeRange.label}` : ''}`,
        title: `השוואה - רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` (${currentAgeRange.label})` : ''}`,
        description: `לא נמצאו קרנות נוספות בקטגוריה ${getCategoryTitle(categoryId)} עם רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` וטווח גיל ${currentAgeRange.label}` : ''} בדיוק`,
        fundIds: [parseInt(currentProduct.id)],
        isDynamic: true,
        riskLevel: riskLevel,
        ageRange: currentAgeRange?.label,
        matchingMethod: 'strict-no-match'
      };

      logComparisonFundIds(result.key, result.fundIds);

      return result;
    }

    // 🔍 בדיקת חשיפת מניות - אם הקרן הנוכחית היא "עד 25% מניות", השווה רק לקרנות דומות
    const currentStockExposure = currentProduct.exposures?.stocks;
    const isLimitedStocks = (currentStockExposure !== null && currentStockExposure !== undefined && currentStockExposure <= 25) ||
                            currentProduct.name.includes('עד 25% מניות') ||
                            currentProduct.name.includes('עד 25 מניות') ||
                            currentProduct.name.includes('אגח עם מניות');
    
    // המשך הקוד כרגיל - סנן לפי מילת מפתח...
    const matchingProducts = exactRiskProducts.filter(product => {
      const productKeywords = extractKeywords(product.name);
      const hasKeywordMatch = productKeywords.includes(primaryKeyword);
      
      // אם הקרן הנוכחית היא "עד 25% מניות", בדוק גם חשיפת מניות דומה
      if (isLimitedStocks && hasKeywordMatch) {
        const productStockExposure = product.exposures?.stocks;
        // אם יש נתוני חשיפה, בדוק שהם דומים (עד 25% או עם סטייה קטנה)
        if (productStockExposure !== null && productStockExposure !== undefined) {
          // השווה רק קרנות עם חשיפת מניות עד 30% (עם טולרנס קטן)
          const tolerance = 5; // אפשר סטייה של 5%
          return productStockExposure <= (currentStockExposure + tolerance);
        }
        // אם אין נתוני חשיפה, בדוק אם השם מכיל "עד 25% מניות" או "אגח עם מניות"
        const productNameLower = product.name.toLowerCase();
        return productNameLower.includes('עד 25% מניות') || 
               productNameLower.includes('עד 25 מניות') ||
               productNameLower.includes('אגח עם מניות');
      }
      
      // אם הקרן הנוכחית היא "מניות בלבד", הימנע מקרנות עם הגבלת מניות
      if (!isLimitedStocks && primaryKeyword === 'מניות' && hasKeywordMatch) {
        const productStockExposure = product.exposures?.stocks;
        // אם יש נתוני חשיפה, בדוק שזה לא "עד 25% מניות"
        if (productStockExposure !== null && productStockExposure !== undefined) {
          // אם חשיפת המניות גבוהה מ-25%, זה כנראה "מניות בלבד"
          return productStockExposure > 25;
        }
        // אם אין נתוני חשיפה, בדוק שהשם לא מכיל "עד 25% מניות" או "אגח עם מניות"
        const productNameLower = product.name.toLowerCase();
        return !productNameLower.includes('עד 25% מניות') && 
               !productNameLower.includes('עד 25 מניות') &&
               !productNameLower.includes('אגח עם מניות');
      }
      
      return hasKeywordMatch;
    });

    console.log(`🎯 Found ${matchingProducts.length} products with keyword "${primaryKeyword}"${isLimitedStocks ? ' (limited stocks ≤25%)' : ''}`);

    if (matchingProducts.length === 0) {
      // נסה מילות מפתח חלופיות - עם אותה בדיקת חשיפת מניות
      const alternativeProducts = exactRiskProducts.filter(product => {
        const productKeywords = extractKeywords(product.name);
        const hasKeywordMatch = keywords.some(keyword => productKeywords.includes(keyword));
        
        if (!hasKeywordMatch) return false;
        
        // אם הקרן הנוכחית היא "עד 25% מניות", בדוק גם חשיפת מניות דומה
        if (isLimitedStocks) {
          const productStockExposure = product.exposures?.stocks;
          if (productStockExposure !== null && productStockExposure !== undefined) {
            const tolerance = 5;
            return productStockExposure <= (currentStockExposure + tolerance);
          }
          const productNameLower = product.name.toLowerCase();
          return productNameLower.includes('עד 25% מניות') || 
                 productNameLower.includes('עד 25 מניות') ||
                 productNameLower.includes('אגח עם מניות');
        }
        
        return true;
      });
      
      if (alternativeProducts.length > 0) {
        console.log(`🔄 Using alternative keywords, found ${alternativeProducts.length} products`);
        
        const scoredProducts = alternativeProducts.map(product => ({
          product,
          score: calculateRelevanceScore(currentProduct, product)
        }));
        
        scoredProducts.sort((a, b) => b.score - a.score);
        const topProducts = scoredProducts.slice(0, 9).map(item => item.product);
        
        const result = {
          key: `strict-risk-${riskLevel}${currentAgeRange ? `-age-${currentAgeRange.label}` : ''}-alternative`,
          title: `השוואה - רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` (${currentAgeRange.label})` : ''}`,
          description: `קרנות בקטגוריה ${getCategoryTitle(categoryId)} עם רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` וטווח גיל ${currentAgeRange.label}` : ''} ומאפיינים דומים`,
          fundIds: [parseInt(currentProduct.id), ...topProducts.map(p => parseInt(p.id))],
          isDynamic: true,
          riskLevel: riskLevel,
          ageRange: currentAgeRange?.label,
          matchingMethod: 'strict-risk-age-alternative-keywords'
        };

        logComparisonFundIds(result.key, result.fundIds);
        
        return result;
      }
      
      // קח את הטובות ביותר באותה רמת סיכון וגיל
      const bestPerforming = exactRiskProducts
        .filter(product => product.returns?.year1 != null)
        .sort((a, b) => (b.returns?.year1 || 0) - (a.returns?.year1 || 0))
        .slice(0, 9);
      
      const bestResult = {
        key: `strict-risk-${riskLevel}${currentAgeRange ? `-age-${currentAgeRange.label}` : ''}-best`,
        title: `השוואה - רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` (${currentAgeRange.label})` : ''}`,
        description: `הקרנות הטובות ביותר בקטגוריה ${getCategoryTitle(categoryId)} עם רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? ` וטווח גיל ${currentAgeRange.label}` : ''}`,
        fundIds: [parseInt(currentProduct.id), ...bestPerforming.map(p => parseInt(p.id))],
        isDynamic: true,
        riskLevel: riskLevel,
        ageRange: currentAgeRange?.label,
        matchingMethod: 'strict-risk-age-best-performing'
      };

      logComparisonFundIds(bestResult.key, bestResult.fundIds);
      
      return bestResult;
    }

    // מצאנו התאמות טובות!
    const scoredProducts = matchingProducts.map(product => ({
      product,
      score: calculateRelevanceScore(currentProduct, product)
    }));

    scoredProducts.sort((a, b) => b.score - a.score);
    const topProducts = scoredProducts.slice(0, 9).map(item => item.product);

    const finalResult = {
      key: `strict-risk-${riskLevel}${currentAgeRange ? `-age-${currentAgeRange.label}` : ''}-${primaryKeyword.replace(/\s+/g, '-')}`,
      title: `השוואה - רמת סיכון ${riskLevel}${currentAgeRange ? ` (${currentAgeRange.label})` : ''} עם "${primaryKeyword}"`,
      description: `קרנות בקטגוריה ${getCategoryTitle(categoryId)} עם רמת סיכון ${riskLevel} כוכבים${currentAgeRange ? `, טווח גיל ${currentAgeRange.label}` : ''} ו"${primaryKeyword}" בשם`,
      fundIds: [parseInt(currentProduct.id), ...topProducts.map(p => parseInt(p.id))],
      isDynamic: true,
      riskLevel: riskLevel,
      ageRange: currentAgeRange?.label,
      matchingMethod: 'strict-risk-age-and-name'
    };

    logComparisonFundIds(finalResult.key, finalResult.fundIds);

    return finalResult;

  } catch (error) {
    console.error('❌ Error in strict dynamic comparison:', error);
    return buildFallbackComparison(currentProduct, categoryId);
  }
};



/**
 * חישוב ציון רלוונטיות בין שני מוצרים
 */
const calculateRelevanceScore = (currentProduct, comparedProduct) => {
  let score = 0;

  // תשואה (40%)
  const currentReturn = currentProduct.returns?.year1 || 0;
  const comparedReturn = comparedProduct.returns?.year1 || 0;
  const returnDiff = Math.abs(currentReturn - comparedReturn);
  score += Math.max(0, 40 - returnDiff);

  // חברה זהה (15%)
  if (currentProduct.company === comparedProduct.company) {
    score += 15;
  }

  // דמיון בשם (20%)
  const nameScore = calculateNameSimilarity(currentProduct.name, comparedProduct.name);
  score += nameScore * 20;

  // דמי ניהול (10%)
  const currentFee = currentProduct.fees?.management || 0;
  const comparedFee = comparedProduct.fees?.management || 0;
  const feeDiff = Math.abs(currentFee - comparedFee);
  score += Math.max(0, 10 - feeDiff * 10);

  // חשיפות דומות (15%)
  const exposureScore = calculateExposureSimilarity(currentProduct, comparedProduct);
  score += exposureScore * 15;

  return score;
};

const logComparisonFundIds = (contextLabel, fundIds) => {
  if (!Array.isArray(fundIds)) {
    console.log(`📊 [${contextLabel}] No fund IDs (non-array value)`);
    return;
  }

  if (fundIds.length === 0) {
    console.log(`📊 [${contextLabel}] Fund IDs: []`);
    return;
  }

  const normalizedIds = fundIds.map((id) => {
    const numericId = parseInt(id, 10);
    return Number.isNaN(numericId) ? id : numericId;
  });

  console.log(`📊 [${contextLabel}] Fund IDs:`, normalizedIds);
};
